(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('[data-announcement-bar][data-dismissible]');
    if (!bar) return;
    var key = 'wallz:announcementDismissed';
    if (!WallZ.utils.getStorage(key, false)) {
      bar.style.display = '';
    }
    var closeBtn = bar.querySelector('[data-announcement-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.style.display = 'none';
        WallZ.utils.setStorage(key, true);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var target;
      if (el.dataset.mode === 'evergreen') {
        var storeKey = 'wallz:countdownStart:' + el.dataset.sectionId;
        var start = WallZ.utils.getStorage(storeKey, null);
        if (!start) { start = Date.now(); WallZ.utils.setStorage(storeKey, start); }
        target = start + (parseFloat(el.dataset.hours) || 24) * 3600 * 1000;
      } else {
        target = new Date(el.dataset.end).getTime();
      }
      var daysEl = el.querySelector('[data-cd-days]'), hoursEl = el.querySelector('[data-cd-hours]'),
        minEl = el.querySelector('[data-cd-minutes]'), secEl = el.querySelector('[data-cd-seconds]');
      function tick() {
        var diff = Math.max(0, target - Date.now());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
        hoursEl.textContent = String(h).padStart(2, '0');
        minEl.textContent = String(m).padStart(2, '0');
        secEl.textContent = String(s).padStart(2, '0');
        if (diff <= 0) clearInterval(interval);
      }
      tick();
      var interval = setInterval(tick, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var input = document.querySelector('[data-faq-search]');
    var items = document.querySelectorAll('[data-faq-item]');
    var noResults = document.querySelector('[data-faq-no-results]');
    if (!input) return;
    input.addEventListener('input', WallZ.utils.debounce(function () {
      var term = input.value.trim().toLowerCase();
      var visibleCount = 0;
      items.forEach(function (item) {
        var text = item.textContent.toLowerCase();
        var match = text.indexOf(term) > -1;
        item.style.display = match ? '' : 'none';
        if (match) visibleCount++;
      });
      document.querySelectorAll('.faq-page__category').forEach(function (cat) {
        var group = cat.nextElementSibling;
        var anyVisible = group && Array.prototype.some.call(group.children, function (c) { return c.style.display !== 'none'; });
        cat.style.display = anyVisible ? '' : 'none';
        if (group) group.style.display = anyVisible ? '' : 'none';
      });
      if (noResults) noResults.hidden = visibleCount !== 0;
    }, 150));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('[data-search-toggle]');
    var panel = document.querySelector('[data-header-search]');
    var closeBtn = document.querySelector('[data-search-close]');
    if (!toggle || !panel) return;
    function open() {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      var input = panel.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 100);
    }
    function close() {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', function () {
      panel.classList.contains('is-open') ? close() : open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Facet accordion collapse
    document.querySelectorAll('[data-facet-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var facet = btn.closest('[data-facet]');
        facet.toggleAttribute('data-collapsed');
      });
    });

    // Filters auto-submit on change
    var form = document.getElementById('FacetFiltersForm');
    if (form) {
      form.addEventListener('change', WallZ.utils.debounce(function () {
        var params = new URLSearchParams(new FormData(form));
        window.location.search = params.toString();
      }, 250));
    }

    // Sort dropdown
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    // Grid / list toggle (persists per-session)
    var results = document.querySelector('.collection-results');
    var savedView = WallZ.utils.getStorage('wallz:collectionView', 'grid');
    if (results) results.setAttribute('data-view', savedView);
    document.querySelectorAll('[data-view]').forEach(function (btn) {
      if (btn.dataset.view === savedView) btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        document.querySelectorAll('.view-toggle__btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (results) results.setAttribute('data-view', btn.dataset.view);
        WallZ.utils.setStorage('wallz:collectionView', btn.dataset.view);
      });
    });

    // Mobile filter drawer
    var toggle = document.querySelector('[data-filter-drawer-toggle]');
    var drawer = document.querySelector('[data-filter-drawer]');
    var overlay = document.querySelector('[data-overlay]');
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        drawer.classList.add('is-open');
        document.body.classList.add('no-scroll');
        if (overlay) overlay.classList.add('is-visible');
      });
      drawer.querySelectorAll('[data-filter-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          drawer.classList.remove('is-open');
          document.body.classList.remove('no-scroll');
          if (overlay) overlay.classList.remove('is-visible');
        });
      });
    }

    // Infinite scroll (progressive enhancement over paginate)
    var grid = document.querySelector('[data-product-grid]');
    var loadMoreBtn = document.querySelector('[data-load-more]');
    if (grid && loadMoreBtn) {
      var nextUrl = grid.dataset.nextUrl;
      function loadMore() {
        if (!nextUrl) { loadMoreBtn.hidden = true; return; }
        loadMoreBtn.classList.add('is-loading');
        fetch(nextUrl)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-product-grid]');
            if (newGrid) {
              grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
              nextUrl = newGrid.dataset.nextUrl || '';
              loadMoreBtn.hidden = !nextUrl;
            } else {
              loadMoreBtn.hidden = true;
            }
            loadMoreBtn.classList.remove('is-loading');
          });
      }
      loadMoreBtn.addEventListener('click', loadMore);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting && !loadMoreBtn.hidden) loadMore();
        }, { rootMargin: '600px' });
        io.observe(loadMoreBtn);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.product-page');
    if (!root) return;
    var productData = JSON.parse(document.querySelector('[data-product-json]').textContent);
    var form = document.querySelector('[data-product-form]');
    var variantIdInput = document.querySelector('[data-product-form-variant-id]');

    /* ---------------- Gallery ---------------- */
    var slides = root.querySelectorAll('[data-gallery-slide]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    function showSlide(i) {
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(parseInt(t.dataset.index, 10)); }); });
    var prevBtn = root.querySelector('[data-gallery-prev]'), nextBtn = root.querySelector('[data-gallery-next]');
    var current = 0;
    if (prevBtn) prevBtn.addEventListener('click', function () { current = (current - 1 + slides.length) % slides.length; showSlide(current); });
    if (nextBtn) nextBtn.addEventListener('click', function () { current = (current + 1) % slides.length; showSlide(current); });

    /* ---------------- Zoom modal ---------------- */
    var zoomModal = document.querySelector('[data-zoom-modal]');
    var zoomImage = document.querySelector('[data-zoom-image]');
    root.querySelectorAll('[data-zoom-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = btn.querySelector('img');
        zoomImage.src = img.dataset.zoomSrc;
        zoomImage.alt = img.alt;
        zoomModal.classList.add('is-open');
      });
    });
    var zoomClose = document.querySelector('[data-zoom-close]');
    if (zoomClose) zoomClose.addEventListener('click', function () { zoomModal.classList.remove('is-open'); });
    if (zoomModal) zoomModal.addEventListener('click', function (e) { if (e.target === zoomModal) zoomModal.classList.remove('is-open'); });

    /* ---------------- Variant selection ---------------- */
    var selectedOptions = [];
    root.querySelectorAll('.option-selector').forEach(function (sel) {
      var index = parseInt(sel.dataset.optionIndex, 10);
      var activePill = sel.querySelector('.option-pill.is-selected');
      selectedOptions[index] = activePill ? activePill.dataset.optionValue : sel.querySelector('.option-pill').dataset.optionValue;
    });

    function findVariant() {
      return productData.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      });
    }

    function updateUI(variant) {
      if (!variant) return;
      variantIdInput.value = variant.id;
      var priceEl = document.querySelector('[data-sale-price]');
      var compareEl = document.querySelector('[data-compare-price]');
      if (priceEl) priceEl.textContent = WallZ.utils.formatMoney(variant.price);
      if (compareEl) { if (variant.compare_at_price > variant.price) { compareEl.textContent = WallZ.utils.formatMoney(variant.compare_at_price); compareEl.style.display = ''; } else { compareEl.style.display = 'none'; } }
      var stickyPrice = document.querySelector('[data-sticky-atc-price]');
      if (stickyPrice) stickyPrice.textContent = WallZ.utils.formatMoney(variant.price);
      var addBtn = document.querySelector('[data-add-to-cart]');
      var stickyBtn = document.querySelector('[data-sticky-atc-submit]');
      [addBtn, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !variant.available;
        var label = btn.querySelector('.btn-label') || btn;
        label.textContent = variant.available ? window.WallZ.strings.addToCart : window.WallZ.strings.soldOut;
      });
      if (variant.featured_image) {
        var idx = productData.images.indexOf(variant.featured_image.src) !== -1
          ? productData.images.indexOf(variant.featured_image.src)
          : Array.prototype.findIndex.call(slides, function (s) { return s.dataset.mediaId === String(variant.featured_image.id); });
        if (idx > -1) showSlide(idx);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    root.querySelectorAll('.option-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var index = parseInt(pill.dataset.optionIndex, 10);
        var group = pill.closest('.option-selector');
        group.querySelectorAll('.option-pill').forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        group.querySelector('[data-option-selected]').textContent = pill.dataset.optionValue;
        selectedOptions[index] = pill.dataset.optionValue;
        updateUI(findVariant());
      });
    });

    /* ---------------- AJAX add to cart ---------------- */
    window.WallZ.strings = window.WallZ.strings || { addToCart: 'Add to Cart', soldOut: 'Sold Out' };
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-to-cart]');
        var stickyBtn = document.querySelector('[data-sticky-atc-submit]');
        btn.classList.add('is-loading');
        if (stickyBtn) stickyBtn.classList.add('is-loading');
        WallZ.Cart.addItem(variantIdInput.value, parseInt(form.quantity.value, 10) || 1)
          .then(function () {
            btn.classList.remove('is-loading');
            if (stickyBtn) stickyBtn.classList.remove('is-loading');
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            if (stickyBtn) stickyBtn.classList.remove('is-loading');
          });
      });
    }

    /* ---------------- Sticky ATC visibility ---------------- */
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var source = document.querySelector('[data-sticky-atc-source]');
    if (stickyBar && source && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        stickyBar.toggleAttribute('hidden', entries[0].isIntersecting);
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(source);
    }

    /* ---------------- Live visitor counter ---------------- */
    var visitorEl = document.querySelector('[data-visitor-counter]');
    if (visitorEl) {
      var key = 'wallz:visitors:' + productData.id;
      var count = WallZ.utils.getStorage(key, Math.floor(Math.random() * 18) + 6);
      visitorEl.querySelector('[data-visitor-count]').textContent = count + ' people viewing this right now';
      WallZ.utils.setStorage(key, count);
      visitorEl.hidden = false;
    }

    /* ---------------- Shipping / pincode estimator (client-side mock) ---------------- */
    var calcToggle = document.querySelector('[data-shipping-calc-toggle]');
    var calcPanel = document.querySelector('[data-shipping-calc]');
    if (calcToggle && calcPanel) {
      calcToggle.addEventListener('click', function () { calcPanel.hidden = !calcPanel.hidden; });
      var checkBtn = document.querySelector('[data-pincode-check]');
      var input = document.querySelector('[data-pincode-input]');
      var result = document.querySelector('[data-pincode-result]');
      if (checkBtn) {
        checkBtn.addEventListener('click', function () {
          if (!/^\d{6}$/.test(input.value.trim())) { result.textContent = 'Please enter a valid 6-digit PIN code.'; return; }
          var threshold = (window.WallZ.settings && window.WallZ.settings.freeShippingThreshold) || 2499;
          result.textContent = 'Delivered in 3-6 business days to ' + input.value.trim() + '. Free shipping on orders above ' + WallZ.utils.formatMoney(threshold * 100) + '.';
        });
      }
    }

    /* ---------------- Recently viewed: save + render ---------------- */
    var rvKey = 'wallz:recentlyViewed';
    var rvList = WallZ.utils.getStorage(rvKey, []);
    rvList = rvList.filter(function (p) { return p.handle !== productData.handle; });
    rvList.unshift({
      handle: productData.handle,
      title: productData.title,
      url: window.location.pathname,
      image: productData.featured_image,
      price: productData.price,
    });
    WallZ.utils.setStorage(rvKey, rvList.slice(0, 12));

    var rvWrap = document.querySelector('[data-recently-viewed-wrap]');
    var rvGrid = document.querySelector('[data-recently-viewed]');
    if (rvWrap && rvGrid) {
      var toShow = rvList.slice(1, 5); // exclude current product
      if (toShow.length > 0) {
        rvWrap.hidden = false;
        rvGrid.innerHTML = toShow.map(function (p) {
          return '<a class="product-card" href="' + p.url + '"><div class="product-card__media"><img class="product-card__img" src="' + p.image + '" loading="lazy" alt="' + p.title + '"></div>' +
            '<div class="product-card__info"><h3 class="product-card__title">' + p.title + '</h3><div class="product-card__price">' + WallZ.utils.formatMoney(p.price) + '</div></div></a>';
        }).join('');
      }
    }
    /* Related products: handled globally by initRecommendations() in theme.js */
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var track = document.querySelector('.reviews__carousel');
    var prev = document.querySelector('[data-review-prev]');
    var next = document.querySelector('[data-review-next]');
    if (!track || !prev || !next) return;
    prev.addEventListener('click', function () { track.scrollBy({ left: -340, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: 340, behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();
})();
